import React from 'react';
import { GridDetailRow } from '@progress/kendo-react-grid';

class MarketplaceOrderListDetail extends GridDetailRow {
	render() {
		const dataItem = this.props.dataItem;
		return (
			<section>
				<p>Test</p>
			</section>
		);
	}
}

export default MarketplaceOrderListDetail;



// WEBPACK FOOTER //
// ./src/themes/default/modules/order/pages/MarketplaceOrderListDetail.jsx